import React, { useEffect, useMemo } from 'react';
import { Cake } from 'lucide-react';

const CONFETTI_COLORS = ['#ff6b6b', '#ffd93d', '#6bcb77', '#4d96ff', '#ff85a2', '#845ef7', '#ff6b6b', '#ffd93d', '#6bcb77', '#4d96ff', '#ff85a2', '#845ef7'];

const ConfettiPiece = ({ style }) => (
  <span className="birthday-confetti-piece" style={style} />
);

const PopperBurst = ({ side = 'right' }) => (
  <div
    className={`birthday-popper-burst birthday-popper-burst--${side}`}
    aria-hidden="true"
  >
    {CONFETTI_COLORS.map((color, index) => {
      const angle = (index / CONFETTI_COLORS.length) * Math.PI * 0.9 + Math.PI * 0.09;
      const distance = 70 + (index % 3) * 18;
      return (
      <ConfettiPiece
        key={`${side}-${index}`}
        style={{
          '--confetti-color': color,
          '--confetti-delay': `${index * 0.08}s`,
          '--confetti-rotate': `${index * 47}deg`,
          '--confetti-x': `${Math.round(Math.cos(angle) * distance)}px`,
          '--confetti-y': `${Math.round(Math.sin(angle) * distance + 40)}px`,
        }}
      />
      );
    })}
  </div>
);

export const BirthdayConfettiOverlay = ({ active }) => {
  useEffect(() => {
    if (!active) return undefined;
    document.body.classList.add('birthday-celebration-active');
    return () => document.body.classList.remove('birthday-celebration-active');
  }, [active]);

  if (!active) return null;

  return (
    <div className="birthday-confetti-overlay" aria-hidden="true">
      <PopperBurst side="right" />
      <PopperBurst side="left" />
    </div>
  );
};

export const BirthdayGreetingBanner = ({ celebration }) => {
  const quote = celebration?.quote;
  const name = celebration?.employee_name;

  if (!celebration?.is_my_birthday_today || !quote) return null;

  const firstName = name?.trim().split(/\s+/)[0];

  return (
    <div className="birthday-greeting-banner mt-3 mb-1 px-4 py-3 rounded-xl flex items-start gap-3 bg-gradient-to-br from-rose-50 to-amber-50 dark:from-rose-950/30 dark:to-amber-950/20 border border-rose-200/60 dark:border-rose-800/40">
      <Cake className="w-5 h-5 text-rose-600 dark:text-rose-400 shrink-0 mt-0.5" />
      <div>
        <p className="text-sm font-semibold text-rose-700 dark:text-rose-300">
          Happy Birthday{firstName ? `, ${firstName}!` : '!'}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-0.5">{quote}</p>
      </div>
    </div>
  );
};

export const useBirthdayCelebration = (payload) => {
  return useMemo(() => {
    if (!payload?.enabled || !payload?.is_my_birthday_today) return null;
    return payload;
  }, [payload]);
};
